export enum InputActions {
  SELECT = 'select',
  PAUSE = 'pause',
  CANCEL = 'cancel',
  BACK = 'back',
  OPTIONS = 'options',
  INTERACT = 'interact',
  MOVE_RIGHT = 'move_right',
  MOVE_LEFT = 'move_left',
  MOVE_UP = 'move_up',
  MOVE_DOWN = 'move_down',
  ATTACK = 'attack',
  DEFEND = 'defend',
  JUMP = 'jump',
  DASH = 'dash',
  SPECIAL = 'special',
  PAGE_UP = 'page_up',
  PAGE_DOWN = 'page_down',
  OTHER1 = 'other1',
}

export enum DialogActions {
  TYPING = 'typing',
}
